const initState = () => {
  return {};
}

const candidate = (state=initState(), action) => {
  switch (action.type) {
    case "CLEAR_CANDIDATE":
      return initState()
      
    case "UPDATE_CANDIDATE_NOTES":
      return {...state, ...{notes: action.payload}};

    case "UPDATE_CANDIDATE_AVATAR":
      const updateAvatar = `${state.avatar}?${new Date().getTime()}`;
      return {...state, ...{avatar: updateAvatar}};

    case "INIT_CANDIDATE":
      return {
        ...state,
        ...action.payload,
        ...{avatar: `${action.payload.avatar}?${new Date().getTime()}`}
      };

    default:
      return state;
  }
}

export default candidate;
